import { TypographyH2, TypographyP } from '@talentmesh/ui/components/typography';
import SectionLoadingState from '../../SectionLoadingState';
import { useEmailIntegrationStatus } from '../api/useOAuthEmailIntegration';
import EmailIntegrationProviders from './IntegrationProviders/EmailIntegrationProviders';
import EmailIntegrationStatus from './IntegrationStatus/EmailIntegrationStatus';
import UIStrings from '@/Utils/UIStrings';

const EmailIntegrationSection = () => {
    const { data, isLoading, error } = useEmailIntegrationStatus();

    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-2">
                <TypographyH2>{UIStrings.EmailIntegration}</TypographyH2>
                <TypographyP>{UIStrings.ConnectYourWorkEmailAccountToEmailAndManage}</TypographyP>
            </div>
            <SectionLoadingState isLoading={isLoading} loadingFailed={!!error}>
                {data ? <EmailIntegrationStatus /> : <EmailIntegrationProviders />}
            </SectionLoadingState>
        </div>
    );
};

export default EmailIntegrationSection;
